import MiniQ2Form from "./MiniQ2Form";
import { useEffect, useState } from "react";

const ManagerGPSForm = ({ item, model }) => {
    const [value, setValue] = useState("");

    useEffect(() => {
        setValue(model);
    }, [model])

    const renderFormByModel = () => {
        switch (value) {
            case "MQ2-4G":
                return <MiniQ2Form item={item} />;
            default:
                return <></>;
        }
    };


    return renderFormByModel();

}
export default ManagerGPSForm;